<template>
    <div v-if="isVisible" class="Notify-banner-overlay">
        <div class="Notify-banner-container">
            <button class="Notify-close-overlay" :class="{'dark-close':blackIcon}" @click="closeBannerPopup">&times;</button>
            <a :href="redirectUrl" target="_blank" rel="noopener noreferrer">
                <img :src="banner" alt="Event Banner" class="Notify-banner-image" @click="closeBannerPopup" />
            </a>
        </div>
    </div>
</template>

<script lang="ts" src="./WindowPopupNotification.ts"></script>
<style lang="scss" src="./WindowPopupNotification.scss"></style>
